import React from 'react';
import PropTypes from 'prop-types';

import { withBrand } from '../../../../providers/BrandProvider';

import ReactTooltip from 'react-tooltip';

import './TierSaveBox.scss';

export function TierSaveBox(props) {
  const {
    children,
    brand: { secondaryColor, accentColor } = {},
    tooltipText = '',
    handleTooltipVisibility,
  } = props;

  const boxStyle = {
    backgroundColor: secondaryColor,
    borderColor: accentColor,
  };

  return (
    children && (
      <>
        <div
          data-tip={tooltipText}
          data-place="bottom"
          data-effect="float"
          className="c-tier-save-box"
          style={boxStyle}
          onClick={handleTooltipVisibility()}
        >
          <i className="material-icons c-tier-save-box__icon">help_outline</i>
          <span className="c-tier-save-box__content">{children}</span>
        </div>
        {tooltipText && (
          <ReactTooltip type="light" className="c-tier-save-box__tooltip" />
        )}
      </>
    )
  );
}

TierSaveBox.propTypes = {
  children: PropTypes.node,
  brand: PropTypes.object,
  tooltipText: PropTypes.string,
  handleTooltipVisibility: PropTypes.func,
};

export default withBrand(TierSaveBox);
